import { gql } from "@apollo/client";

export const GET_ALL_CODIGO_POSTAL_WITH_OUT_FILTER = gql`
query allCodigoPostalWithOutFilter{
    allCodigoPostalWithOutFilter{
        idCodigoPostal,
        cP,
        idProvincia,
        localidad,
        idTipoZona,
        idProvinciaNavigation {
          idProvincia,
          descripcion
        },
        idTipoZonaNavigation {
          idTipoZona,
          descripcion
        }
    }
 }
`;